import React__default, { useRef, useLayoutEffect, useEffect } from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { Button } from '../Button/index.js';
import { OffCanvasContainer } from '../OffCanvasContainer/index.js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import styles from 'ui-components/OffCanvasSortMenu.scss';

var DefaultCloseIcon = function DefaultCloseIcon() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "close",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M24.5454545,10 L26,11.4545455 L19.454,18 L26,24.5454545 L24.5454545,26 L18,19.454 L11.4545455,26 L10,24.5454545 L16.546,18 L10,11.4545455 L11.4545455,10 L18,16.546 L24.5454545,10 Z",
    id: "Combined-Shape-Copy",
    fill: "#3D3835"
  })));
};
var OffCanvasSortMenu = function OffCanvasSortMenu(_ref) {
  var isOpen = _ref.isOpen,
    close = _ref.close,
    _ref$side = _ref.side,
    side = _ref$side === void 0 ? "LEFT" : _ref$side,
    filterState = _ref.filterState,
    _ref$CloseIcon = _ref.CloseIcon,
    CloseIcon = _ref$CloseIcon === void 0 ? DefaultCloseIcon : _ref$CloseIcon;
  var t = useTranslate();
  var sortNode = useRef(null);
  var _filterState$sort = filterState.sort,
    values = _filterState$sort.values,
    value = _filterState$sort.value,
    setValue = _filterState$sort.setValue;
  if (process.browser) {
    /* Temporary disable eslint rule because this part
     * will be removed in compilation for server */

    /* eslint-disable react-hooks/rules-of-hooks */
    useLayoutEffect(function () {
      if (isOpen && document.body && sortNode.current) {
        disableBodyScroll(sortNode.current);
      }
      if (!isOpen && document.body && sortNode.current) {
        enableBodyScroll(sortNode.current);
      }
    }, [isOpen]);
    /* eslint-enable react-hooks/rules-of-hooks */
  }

  useEffect(function () {
    if (sortNode.current) {
      var _sortNode$current$que;
      (_sortNode$current$que = sortNode.current.querySelector("button")) == null || _sortNode$current$que.focus();
    }
  }, [isOpen]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OffCanvasContainer, {
    isOpen: isOpen,
    close: close,
    side: side
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React__default.createElement("h2", null, t("SORT.OFFCANVAS.TITLE")), /*#__PURE__*/React__default.createElement(Button, {
    className: styles.closeButton,
    "aria-label": t("SORT.OFFCANVAS.CLOSE_MENU"),
    onClick: function onClick() {
      return close();
    }
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))), /*#__PURE__*/React__default.createElement("div", {
    className: styles.body
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: sortNode,
    className: styles.top
  }, values && values.map(function (v) {
    var _cn;
    return /*#__PURE__*/React__default.createElement(Button, {
      key: v.code,
      className: cn(styles.value, (_cn = {}, _cn[styles.active] = v.code === value, _cn)),
      onClick: function onClick() {
        return setValue(v.code);
      }
    }, /*#__PURE__*/React__default.createElement("span", null, v.label));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.bottom
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: styles.submit_button,
    variant: "primary",
    onClick: function onClick() {
      return close();
    }
  }, t("SORT.OFFCANVAS.SHOW_RESULT"))))));
};

export { OffCanvasSortMenu };
//# sourceMappingURL=index.js.map
